// extracted by mini-css-extract-plugin
export default {"drag_box":"DragResize_drag_box__Psdg6","drag_target":"DragResize_drag_target__yN7VB"};